const bgMap = {
  preset1: `linear-gradient(277deg, #6A41D7 0%, #DA90CB 100%)`,
  preset2: `linear-gradient(45deg, #FF2525 0%, #FFE53B 100%)`,
  preset3: `linear-gradient(45deg, #F9C7FF 0%, #9E63FF 50%, #0023FF 100%)`,
  preset4: `linear-gradient(45deg, #1D0127 0%, #6602C6 33.33%, #AD24E2 66.67%, #CC17BA 100%)`,
  preset5: `linear-gradient(135deg, #0230A8 0%, #FF6EB3 100%)`,
  preset6: `linear-gradient(277deg, #6571FC 0%, #FF6B59 100%)`,
  preset7: 'linear-gradient(45deg, #1F005C 0%, #940D60 33.33%, #DA5F5C 66.67%, #FFB56B 100%)',
  preset8: 'linear-gradient(45deg, #FF0037 0%, #FF90A8 100%)',
  preset9: 'linear-gradient(45deg, #00F3FF 0%, #3524FF 100%)',
  preset10: 'linear-gradient(45deg, #FEA564 0%, #FFE68C 100%)',
  preset11: 'linear-gradient(45deg, #FFD98C 0%, #FF9F93 50%, #FF99C5 100%)',
  preset12: 'linear-gradient(135deg, #FF66AC 0%, #63CFFF 100%)',
  preset13: 'linear-gradient(45deg, #06B46D 0%, #08D79B 50%, #0DF6CF 100%)',
  preset14: 'linear-gradient(45deg, #CF2F98 0%, #6A3DEC 100%)',
  preset15: 'linear-gradient(45deg, #110B2A 0%, #6465F1 33.33%, #92DAFF 66.67%, #F9F7F8 100%)',
  preset16: 'linear-gradient(45deg, #363654 0%, #BDE3EC 100%)',
  preset17: 'linear-gradient(45deg, #D9F4FF 0%, #FF8FA7 50%, #5D68FF 100%)',
  preset18: 'linear-gradient(45deg, #00B09E 0%, #134D5D 50%, #10171F 100%)',
  preset19: 'linear-gradient(45deg, #001233 0%, #0466C8 100%)',
  preset20: 'linear-gradient(45deg, #FF197D 0%, #2D0DFF 50%, #00FFB3 100%)',
  slate: '#64748B',
  gray: '#6B7280',
  zinc: '#71717A',
  neutral: '#737373',
  stone: '#78716C',
  red: '#EF4444',
  orange: '#F97316',
  amber: '#F59E0B',
  yellow: '#EAB308',
  lime: '#84CC16',
  green: '#22C55E',
  emerald: '#10B981',
  teal: '#14B8A6',
  cyan: '#06B6D4',
  sky: '#0EA5E9',
  blue: '#3B82F6',
  indigo: '#6366F1',
  violet: '#8B5CF6',
  purple: '#A855F7',
  fuchsia: '#D946EF',
  pink: '#EC4899',
  rose: '#F43F5E',
};

export function calcBgColor(bgColor: any): string | undefined {
  const bg = typeof bgColor === 'string' ? bgColor : 'preset1';

  if (bg in bgMap) {
    return bgMap[bg as keyof typeof bgMap];
  }

  if (bgColor.includes(',')) return undefined;
  return bgColor;
}

export function calcBgLinearColor(bgColor: any, bgDirection: number): string | undefined {
  if (bgColor.includes(',')) return `linear-gradient(${bgDirection}deg, ${bgColor})`;

  return undefined;
}
